"use client";

import { useState } from "react";
import { LuCheck } from "react-icons/lu";
import { cn } from "~/utils/fontsConfig";

import {
    Command,
    CommandGroup,
    CommandInputV4,
    CommandItem,
} from "~/components/shadcn/Command";
import {
    Popover,
    PopoverContent,
    PopoverTrigger,
} from "~/components/shadcn/Popover";
import { SelectCustomization } from "~/types/CustomizableLayout";
interface CapacityInputProps {
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
    className?: string;
    suffixComponent?: React.ReactNode;
    customization?: SelectCustomization;
}

export const CapacityInput = ({
    value,
    onChange,
    disabled = false,
    className,
    suffixComponent,
    customization,
}: CapacityInputProps) => {
    const [open, setOpen] = useState(false);
    const [inputValue, setInputValue] = useState("");

    const handleSelect = (selectedValue: string) => {
        onChange(selectedValue);
        setOpen(false);
        setInputValue("");
    };

    return (
        <div className="flex flex-col gap-2">
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <div
                        role="combobox"
                        aria-expanded={open}
                        className={cn(
                            "flex h-full min-h-10 w-full cursor-pointer justify-between bg-v3-N-500 p-2 transition-colors hover:bg-v3-N-500/90",
                            "border border-transparent hover:border-v3-clover focus:border-v3-clover focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
                            "whitespace-normal rounded-[10px] text-left align-top",
                            open && "border border-v3-clover",
                            className,
                            customization?.inputClassName,
                        )}
                    >
                        {value}
                        <div className="ml-2 mt-1 shrink-0 self-start opacity-50">
                            {suffixComponent}
                        </div>
                    </div>
                </PopoverTrigger>
                <PopoverContent className="w-[var(--radix-popover-trigger-width)] border-none p-0">
                    <Command>
                        <CommandInputV4
                            placeholder="Enter capacity..."
                            value={inputValue}
                            onValueChange={setInputValue}
                            wrapperClass={customization?.inputClassName}
                            className={customization?.className}
                            isSearch={false}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && inputValue) {
                                    handleSelect(inputValue);
                                }
                            }}
                        />
                        <CommandGroup className={customization?.listClassName}>
                            {inputValue && (
                                <CommandItem
                                    value={inputValue}
                                    onSelect={handleSelect}
                                    isSearch={false}
                                    className={customization?.itemClassName}
                                >
                                    {inputValue}
                                </CommandItem>
                            )}
                            <CommandItem
                                value="unlimited"
                                onSelect={handleSelect}
                                className={customization?.itemClassName}
                            >
                                Unlimited
                                <LuCheck
                                    className={cn(
                                        "ml-auto h-4 w-4",
                                        value === "unlimited"
                                            ? "opacity-100"
                                            : "opacity-0",
                                    )}
                                />
                            </CommandItem>
                        </CommandGroup>
                    </Command>
                </PopoverContent>
            </Popover>
        </div>
    );
};
